export default __webpack_public_path__ + "static/media/react.2dd41da5.svg";